export default __webpack_public_path__ + "static/media/forest.4408af86.svg";